// extracted by mini-css-extract-plugin
export default {"image":"Consents_image__F+yM-","agreementList":"Consents_agreementList__1OPQm","agreement":"Consents_agreement__nGBHO"};